
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { UserCard } from "./UserCard";
import { ScrollArea } from "@/components/ui/scroll-area";

export function UserList() {
  const { data: users, isLoading } = useQuery({
    queryKey: ["users"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    },
  });

  if (isLoading) {
    return <div className="p-4 text-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
      <p className="text-muted-foreground">Loading system users...</p>
    </div>;
  }

  if (!users?.length) {
    return <div className="text-center p-8">
      <p className="text-lg font-medium">No users found</p>
      <p className="text-muted-foreground">There are no users in the system yet.</p>
    </div>;
  }

  return (
    <ScrollArea className="h-[500px] rounded-md border">
      <div className="divide-y">
        {users?.map((user) => (
          <UserCard key={user.id} user={user} />
        ))}
      </div>
    </ScrollArea>
  );
}
